import type { AppliedFilter, FilterArrayItem, ShipmentTab } from '../types';
import { buildShipmentFiltersPayload } from './buildShipmentFiltersPayload';

export type MassActionFiltersPayload = Record<string, unknown> & {
  tab_id?: string;
};

type Args = {
  activeTabId: string;
  appliedFilters: AppliedFilter[];
  filterArray: FilterArrayItem[];
  customTabs: ShipmentTab[];
  currentPayload?: Record<string, unknown> | null;
};

export const buildMassActionFiltersPayload = ({
  activeTabId,
  appliedFilters,
  filterArray,
  customTabs,
  currentPayload,
}: Args): MassActionFiltersPayload => {
  if (activeTabId === 'all_shipments' || activeTabId === 'active') {
    return {
      ...(currentPayload ?? {}),
      tab_id: activeTabId,
    };
  }

  const customTab = customTabs.find((tab) => tab.id === activeTabId);
  if (!customTab) {
    return currentPayload ?? {};
  }

  return (
    buildShipmentFiltersPayload(
      [...(customTab.savedFilterSet?.filters ?? []), ...filterArray],
      [...(customTab.savedFilterSet?.appliedFilters ?? []), ...appliedFilters]
    ) ?? {}
  );
};
